export default function Action ({ children }) {
  return (
    <div className='my-5'>
      {children}
    </div>
  )
}
